import type { EGoalType, IPredicate, TComparison } from '@feathr/blackbox';

export function buildURLVisitPredicates(url: string, matchMode: TComparison): IPredicate[] {
  return [
    {
      kind: 'activity',
      attr_type: 'string',
      attr_against: 'loc_url',
      comparison: matchMode,
      value: url,
    },
  ];
}

export function buildFormSubmissionPredicates(formIds?: string[]): IPredicate[] {
  const basePredicates: IPredicate[] = [
    {
      kind: 'activity',
      attr_type: 'string',
      attr_against: 'flvr',
      comparison: 'eq',
      value: 'form_submission',
    },
    {
      kind: 'activity',
      attr_type: 'string',
      attr_against: 'form_type',
      comparison: 'eq',
      value: 'feathr_native',
    },
  ];

  if (formIds && formIds.length > 0) {
    basePredicates.push({
      kind: 'activity',
      attr_type: 'list',
      attr_against: 'form_id',
      comparison: 'in',
      value: formIds,
    });
  }

  return [{ group: basePredicates, group_mode: 'match_all' }];
}

export function buildDonationFormSubmissionPredicates(formIds?: string[]): IPredicate[] {
  const basePredicates: IPredicate[] = [
    {
      kind: 'activity',
      attr_type: 'string',
      attr_against: 'flvr',
      comparison: 'eq',
      value: 'form_submission',
    },
    {
      kind: 'activity',
      attr_type: 'string',
      attr_against: 'form_type',
      comparison: 'eq',
      value: 'donation',
    },
  ];

  if (formIds && formIds.length > 0) {
    basePredicates.push({
      kind: 'activity',
      attr_type: 'list',
      attr_against: 'form_id',
      comparison: 'in',
      value: formIds,
    });
  }

  return [{ group: basePredicates, group_mode: 'match_all' }];
}

export const goalPresets: Record<EGoalType, unknown> = {
  page_view: { attr_against: 'trgt', comparison: 'eq', value: undefined },
  group_entry: { attr_against: '', comparisons: [] },
  conversion_pixel: { attr_against: 'seg_id', comparisons: ['eq'] },
  donation: {
    group: [
      {
        kind: 'activity',
        attr_type: 'string',
        group_mode: 'match_all',
        attr_against: 'flvr',
        comparison: 'eq',
        value: 'form_submission',
      },
      {
        kind: 'activity',
        attr_type: 'string',
        group_mode: 'match_all',
        attr_against: 'form_type',
        comparison: 'eq',
        value: 'donation',
      },
    ],
  },
  form_submission: {
    group: [
      {
        kind: 'activity',
        attr_type: 'string',
        group_mode: 'match_all',
        attr_against: 'flvr',
        comparison: 'eq',
        value: 'form_submission',
      },
      {
        kind: 'activity',
        attr_type: 'string',
        group_mode: 'match_all',
        attr_against: 'form_type',
        comparison: 'eq',
        value: 'feathr_native',
      },
    ],
  },
};
